import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {ApprovalPending} from '../../shared/dto/approval-pending';
import {ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material';
import {ReversedSuspendService} from '../../shared/service/reversed-suspend.service';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';

@Component({
  selector: 'app-reversed-suspend-return-request-viewer',
  templateUrl: './reversed-suspend-return-request-viewer.component.html',
  styleUrls: ['./reversed-suspend-return-request-viewer.component.scss']
})
export class ReversedSuspendReturnRequestViewerComponent implements OnInit {

  public userName: string;
  public type: string;
  blacklistForm: FormGroup;
  public approvalPendingList: ApprovalPending[];
  approvalPending: ApprovalPending = new ApprovalPending();
  displayedColumns: string[] = ['refNo', 'nic', 'name', 'cdc' ,'stage', 'createdDate', 'action'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private route: ActivatedRoute, private suspendService: ReversedSuspendService,
              private tokenStorageService: TokenStorageService) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
    this.userName=this.tokenStorageService.getUserObjectToken().username;
  }

  ngOnInit() {
    this.blacklistForm = new FormGroup({
      appRefNo: new FormControl(null),
      name: new FormControl(null),
      nic: new FormControl(null),
      cdcNo: new FormControl(null),
    });

    this.getAllRequestDetails();
  }

  setBase64(code: string): string {
    return btoa(code);
  }

  getAllRequestDetails(){
    if(this.tokenStorageService.getUserObjectToken().userroleCode === UserRoleEnum.SHO){
      this.approvalPending.appRefNo = this.blacklistForm.value.appRefNo;
      this.approvalPending.cdcNo = this.blacklistForm.value.cdcNo;
      this.approvalPending.name = this.blacklistForm.value.name;
      this.approvalPending.nic = this.blacklistForm.value.nic;
      this.approvalPending.loginUser = this.userName;
      this.approvalPending.type = this.type;

      this.suspendService.getAllReturnRequestData(this.approvalPending).subscribe(
        (result: ApprovalPending[]) => {
          this.approvalPendingList = result;
          this.dataSource = new MatTableDataSource(this.approvalPendingList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      )

    }else if(this.tokenStorageService.getUserObjectToken().userroleCode === UserRoleEnum.EXM){
      this.approvalPending.appRefNo = this.blacklistForm.value.appRefNo;
      this.approvalPending.cdcNo = this.blacklistForm.value.cdcNo;
      this.approvalPending.name = this.blacklistForm.value.name;
      this.approvalPending.nic = this.blacklistForm.value.nic;
      this.approvalPending.loginUser = this.userName;
      this.approvalPending.type = this.type;
      this.suspendService.getAllDGReturnRequestData(this.approvalPending).subscribe(
        (result: ApprovalPending[]) => {
          this.approvalPendingList = result;
          this.dataSource = new MatTableDataSource(this.approvalPendingList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      )
    }
  }

  onSearch() {
    this.approvalPending.appRefNo = this.blacklistForm.value.appRefNo;
    this.approvalPending.cdcNo = this.blacklistForm.value.cdcNo;
    this.approvalPending.name = this.blacklistForm.value.name;
    this.approvalPending.nic = this.blacklistForm.value.nic;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = this.type;

    this.suspendService.searchReversedRequestData(this.approvalPending).subscribe(
      (result: any ) => {
        // alert("asd");
        this.approvalPendingList = result;
        this.dataSource = new MatTableDataSource(this.approvalPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onReset() {
    this.blacklistForm.reset({
      sidNo: null,
      name: null,
      nicNo: null,
      cdcNo: null,
    });
    this.getAllRequestDetails();
  }

}
